import React from "react";

export default function WinnerModal({ winner, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
      <div className="bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl p-8 shadow-2xl flex flex-col items-center animate-bounceIn">
        <h2 className="font-bold text-2xl mb-2">🎉 Winner!</h2>
        <div className="font-mono text-5xl text-black mb-2">
          {winner.number}
        </div>
        <div className="text-lg font-bold">
          {winner.username} won ${winner.amount}!
        </div>
        <button
          className="mt-6 px-4 py-2 rounded-xl bg-black bg-opacity-20 text-white"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
